import * as React from "react";
import { styled, alpha } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Menu, { MenuProps } from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { MoreVert } from "@mui/icons-material";

const StyledMenu = styled((props: MenuProps) => (
    <Menu
        elevation={0}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{vertical: "top", horizontal: "right" }}
        {...props}
    />
))(({ theme }) => ({
    "& .MuiPaper-root": {
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 180,
        color: theme.palette.mode === "light" ? "rgb(55, 65, 81)" : theme.palette.grey[300],
        boxShadow: "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
        "& .MuiMenu-list": { padding: "4px 0" },
        "& .MuiMenuItem-root": {
            "& .MuiSvgIcon-root": {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
            },
            "&:active": {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity
                ),
            },
        },
    },
}));

export default function CustomMenu(props) {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleAction = (row, key) => {
        setAnchorEl(null);
        props.action(row, key);
    };

    return (
        <div>
            <Button
                aria-controls={open ? "demo-customized-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                variant="text"
                disableElevation
                onClick={handleClick}
                disabled={props.options.length === 0}
                sx={{minWidth: props.width || "auto", boxSizing: "content-box", height: props.height || "auto", boxShadow: props.border && "0px 2px 7px #EDF0F4", border: props.border && "1px solid #3743AA41" }}
            >
                {props.icon || <MoreVert />}
            </Button>

            <StyledMenu
                id="demo-customized-menu"
                MenuListProps={{ "aria-labelledby": "demo-customized-button" }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                {props.options.length > 0 &&
                    props.options.map((item) => {
                        return (
                            <MenuItem key={item.key} onClick={() => handleAction(props.row, item.key)} disableRipple>
                                {item.icon}
                                {item.label}
                            </MenuItem>
                        );
                    })}
            </StyledMenu>
        </div>
    );
}
